import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { isRunningOnClientSide } from '../../utils/func';
import { useParams } from 'react-router-dom';
import { resetPassword } from '../../data/resetPassword/actions';
import Preloader from '../../components/common/preloader/Preloader';
import Logo from '../../assets/img/playrence-logo.png';
import User from '../../assets/svg/user.svg';
import Key from '../../assets/svg/key.svg';
import styles from './resetPassword.css';

/**
 *
 * @type {React.NamedExoticComponent<{resetPasswordActions?: *, location?: *, content?: *, resetPassword?: *}>}
 */
const ResetPassword = React.memo( ( { location } ) => {

    const dispatch = useDispatch();
    const { localization: { content } } = useSelector( ( state ) => state );
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const params = new URLSearchParams( location.search );
    const { token } = useParams();
    const [formData, setFormData] = useState({
        token: token,
        email: params.get( 'email' ),
        password: '',
        password_confirmation: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleResetPassword = e => {
        e.preventDefault();

        new Promise((resolve, reject) => {
            setLoading(true);
            setMessage(null);
            dispatch(resetPassword(formData, resolve, reject));
        }).then((response) => {
            setLoading(false);
            setErrors({});
            setMessage(response.message);
            setFormData({
                token: token,
                email: '',
                password: '',
                password_confirmation: '',
            });
        }).catch((errors) => {
            setLoading(false);
            setErrors(errors);
        });
    };

    return (
        <div className={ styles.wrapper }>
            <div className={ styles.logoWrap }>
                <img src={Logo} alt='Playrence Logo' className={ styles.logo } />
            </div>
            { isRunningOnClientSide() && <CSSTransition
                in={ true }
                appear={ true }
                timeout={ 2000 }
                classNames={ {
                    appear: styles[ 'fadeInUp-appear' ],
                    appearActive: styles[ 'fadeInUp-appear-active' ]
                } }
            >
                <form
                    className={ styles.form }
                    onSubmit={ handleResetPassword }
                    autoComplete='off'
                >
                    <div className={ styles.blur }/>

                    <span className={ styles.heading }>
                        {content.reset_password.reset_password}
                    </span>
                    <div className={ styles.fieldWrap }>
                        <User className={ styles.fieldIcon }/>
                        <input
                            autoFocus={ true }
                            className={ styles.input }
                            name='email'
                            placeholder={content.reset_password.enter_email}
                            type='email'
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                        {errors.email && <span className={styles.wrongCred}>{errors.email[0]}</span>}
                        {errors.message && <span className={styles.wrongCred}>{errors.message}</span>}
                        {message && <span className={styles.rightCred}>{message}</span>}
                    </div>
                    <div className={ styles.fieldWrap }>
                        <Key className={ styles.fieldIcon }/>
                        <input
                            className={ styles.input }
                            name='password'
                            placeholder={content.reset_password.enter_password}
                            type='password'
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                        {errors.password && <span className={styles.wrongCred}>{errors.password[0]}</span>}
                    </div>
                    
                    <div className={ styles.fieldWrap }>
                        <Key className={ styles.fieldIcon }/>
                        <input
                            className={ styles.input }
                            name='password_confirmation'
                            placeholder={content.reset_password.enter_confirm_password}
                            type='password'
                            value={formData.password_confirmation}
                            onChange={handleChange}
                            required
                        />
                        {errors.password_confirmation && <span className={styles.wrongCred}>{errors.password_confirmation[0]}</span>}
                    </div>
                    { loading ? <Preloader/> : null }
                    <button type='submit' className={ styles.button } disabled={loading}>
                        {content.reset_password.reset_password}
                    </button>
                </form>
            </CSSTransition> }
        </div>
    );

} );

export default ResetPassword;